export const buildNumber = '20260625.3';
export const version = 'main';
export const latestCommit = '4429ec11aa28a3fd2f2a81b3ad707ebaef4e73e1';
